import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Slide
} from "@mui/material";
import { useLanguage } from '../i18n/LanguageContext';

const ConsultancyPopup = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Open popup after 10 seconds
    const timer = setTimeout(() => {
      setOpen(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Slide direction="left" in={open} mountOnEnter unmountOnExit>
      <Paper
        elevation={5}
        sx={{
          position: "fixed",
          bottom: { xs: 10, sm: 14, md: 18 },
          right: { xs: 10, sm: 14, md: 18 },
          width: { xs: 180, sm: 210, md: 240 },
          maxHeight: { xs: 200, sm: 220, md: 240 },
          zIndex: 9999,
          p: { xs: 1.2, md: 1.5 },
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          display: "flex",
          flexDirection: "column",
          gap: 0.8,
          overflow: "hidden",
          boxShadow: 3,
          "@keyframes boxBlink": {
            "0%": { opacity: 1 },
            "45%": { opacity: 1 },
            "50%": { opacity: 0.3 },
            "55%": { opacity: 1 },
            "100%": { opacity: 1 }
          },
          animation: "boxBlink 5s linear infinite"
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start"
          }}
        >
          <Typography
            component="div"
            sx={{
              fontSize: { xs: "0.85rem", md: "0.95rem" },
              fontWeight: 600,
              lineHeight: 1.2
            }}
          >
            {t("consultancyPopup.title")}
          </Typography>

          <Typography
            component="span"
            onClick={handleClose}
            sx={{
              cursor: "pointer",
              color: "text.secondary",
              fontSize: { xs: "0.9rem", md: "1rem" },
              ml: 1,
              "&:hover": { color: "text.primary" }
            }}
          >
            ✕
          </Typography>
        </Box>

        {/* Instruction */}
        <Typography
          color="text.secondary"
          sx={{
            fontSize: { xs: "0.7rem", md: "0.8rem" },
            lineHeight: 1.3
          }}
        >
          {t("consultancyPopup.instruction")}{" "}
          <Box
            component="span"
            sx={{
              fontWeight: 700,
              color: "primary.main",
              "@keyframes blink": {
                "0%": { opacity: 1 },
                "90%": { opacity: 1 },
                "95%": { opacity: 0 },
                "100%": { opacity: 1 }
              },
              animation: "blink 5s infinite"
            }}
          >
            (Free)
          </Box>
        </Typography>

        {/* Button */}
        <Box
          component="a"
          href="/contact"
          sx={{
            mt: 0.8,
            display: "block",
            textAlign: "center",
            bgcolor: "primary.main",
            color: "white",
            py: { xs: 0.6, md: 0.8 },
            borderRadius: 1,
            textDecoration: "none",
            fontWeight: 600,
            fontSize: { xs: "0.75rem", md: "0.85rem" },
            transition: "0.2s ease-in-out",
            "@keyframes pulse": {
              "0%": { transform: "scale(1)" },
              "2%": { transform: "scale(1.06)" },
              "4%": { transform: "scale(1)" },
              "100%": { transform: "scale(1)" }
            },
            animation: "pulse 5s infinite",
            "&:hover": {
              bgcolor: "primary.dark"
            }
          }}
        >
          {t("consultancyPopup.openForm")}
        </Box>
      </Paper>
    </Slide>
  );
};

export default ConsultancyPopup;
